import React from "react";
import _ from "lodash";
import { url } from "lib/format";
import SettingStore from "stores/settings";
import FallbackImage from "./fallback-image";
import MenuNode from "./menu-node";
import caption from "lib/translation";
import LuvitComponent from "LuvitComponent";

export default class MyLatestCourses extends LuvitComponent {
  constructor(context, props) {
    super(context, props, "Menu");
  }

  async componentWillMount() {
    var courseState = JSON.parse(
      luvit.getItem("luvit_portalmenustate") || "{}",
    ).mycourses;
    this.setState({ expanded: courseState !== false });

    let mylatestcourses = await caption("ActivityCentre", "mylatestcourses");
    this.setState({ mylatestcourses });
  }

  toggle(event) {
    event.stopPropagation();
    if (
      !["menu-select", "latest-courses"].includes(event.target.id) &&
      event.target.className !== "menu-link course-link"
    ) {
      var state = JSON.parse(luvit.getItem("luvit_portalmenustate") || "{}");
      state.mycourses = !this.state.expanded;
      luvit.setItem("luvit_portalmenustate", JSON.stringify(state));
      this.setState({ expanded: !this.state.expanded });
    }
    if (!this.props.expanded) {
      this.props.onExpand(true);
    }
  }

  goToCourse(url) {
    if (url == "0") return;
    location.href = url;
  }

  renderLink(course) {
    const displayMenuImage =
      SettingStore.getSettingValue("showcourseimageinportal") === "1";

    const urlPrefix = url("/education/entercourse.aspx?courseid=");
    const onlineCourseURL = course.munioURL
      ? course.munioURL
      : urlPrefix + course.id;
    const imageUrl =
      "/utils/streamfile.aspx?type=coursecoursecatalogue&param=" +
      Number(course.id) +
      "/" +
      encodeURIComponent(course.image);
    const courseTitleAbbreviation = (course.title || "")
      .substr(0, 2)
      .toUpperCase();

    return (
      <li
        className="menu-expandlist-item"
        key={course.id}
        role="menuitem"
        title={course.title}
      >
        <a
          href={onlineCourseURL}
          {...(course.munioURL && { target: "_blank" })}
          className="flex flex-space-b"
        >
          <span className="menu-link course-link">{course.title}</span>
          {displayMenuImage && (
            <FallbackImage
              style={{ backgroundImage: "url('" + url(imageUrl) + "')" }}
              title={course.title}
              aria-hidden="true"
            >
              <div className="menu-image menu-courseimagefallback">
                {courseTitleAbbreviation}
              </div>
            </FallbackImage>
          )}
          {!displayMenuImage && (
            <div
              className="menu-image menu-courseimagefallback"
              title={course.title}
              aria-hidden="true"
            >
              {courseTitleAbbreviation}
            </div>
          )}
        </a>
      </li>
    );
  }

  renderDropdown() {
    let sortedCourses = JSON.parse(JSON.stringify(this.props.courses));
    sortedCourses = sortedCourses.sort(function (a, b) {
      return a.title.toLowerCase() > b.title.toLowerCase()
        ? 1
        : b.title.toLowerCase() > a.title.toLowerCase()
          ? -1
          : 0;
    });

    let urlPrefix = url("/education/entercourse.aspx?courseid=");

    return (
      <li className="menu-expandlist-item" role="menuitem">
        <select
          id="menu-select"
          className="menu-select"
          name={this.l("gotocourseleftmenu")}
          aria-label={this.l("gotocourseleftmenu")}
          onChange={(e) => this.goToCourse(e.target.value)}
        >
          <option className="choose" value="0">
            {this.l("gotocourseleftmenu")}
          </option>
          {sortedCourses.map((c) => (
            <option key={c.id} className="course" value={urlPrefix + c.id}>
              {c.title}
            </option>
          ))}
        </select>
      </li>
    );
  }

  doRender() {
    const { courses } = this.props;

    return (
      <MenuNode
        type="menu-expandlist-header"
        className="first"
        label={this.state.mylatestcourses}
        icon={"icon-courses"}
        itemId={"latest-courses"}
        title={this.state.mylatestcourses}
        expanded={this.state.expanded}
        expandable={false}
        onExpand={(e) => this.toggle(e)}
      >
        {_.take(courses, window.noOfCoursesInLeftMenu || 0).map((c) =>
          this.renderLink(c),
        )}
        {courses.length > (window.noOfCoursesInLeftMenu || 0) &&
          this.renderDropdown()}
      </MenuNode>
    );
  }
}
